import Text from '../Text/index';
import '../DropdownMenu/dropdownMenu.css';

import { HashLink } from 'react-router-hash-link';

import '../DropdownMenu/dropdownMenu.css';

const DropdownMenu = (props) => {
  const { page } = props;
  const classNameDropdown = `dropdownMenu-list_${page}`;

  return (
    <div className="dropdownMenu">
      <div className="dropdownMenu-points">
        <ul className={classNameDropdown}>
          {props.items.map((item) => (
            <li className="dropdownMenu-points_page" key={item.id}>
              <HashLink to={item.address} href={item.link}>
                <Text component="span" section="link">
                  {item.title}
                </Text>
              </HashLink>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
export default DropdownMenu;
